// @flow
import remove from './utils/remove';

type Callback = {
   // eslint-disable-next-line
   <T>(...args: Array<T>): mixed,
   _safe_inner?: boolean
};

export default class MicroEvent {
   _events: { [key: string]: Callback[] } = {}

   on(event: string, fct: Callback) {
      this._events[event] = this._events[event] || [];
      this._events[event].push(fct);
   }

   off(event: string, fct: Callback) {
      this._events = this._events || {};
      if ( event in this._events === false  ) {
         return;
      }
      remove(this._events[event], fct);
   }

   once(event: string, fct: Callback) {
      const callback = (...args: Array<mixed>) => {
         this._call(fct, args);
         this.off(event, callback);
      };

      this.on(event, callback);
   }

   emit(event: string, ...args: Array<mixed>) {
      if ( event !== '*' ) {
         // $FlowFixMe
         this.emit.apply(this, ['*', event].concat(args));
      }

      this._events = this._events || {};
      if ( event in this._events === false ) {
         return;
      }
      for (var i = this._events[event].length - 1; i >= 0; i--) {
         this._call(this._events[event][i], args);
      }
   }

   destroy() {
      this._events = {};
   }

   _call<T>(fnc: Callback, args: Array<T>) {
      if (fnc._safe_inner) {
         fnc.apply(this, args);
      } else {
         try {
            fnc.apply(this, args);
         } catch (e) {
            console.error(e); // eslint-disable-line
         }
      }
   }
}
